/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IStopShipperFacilityFragment = { __typename?: 'MergedFacility' } & {
  metadata?: Types.Maybe<
    { __typename?: 'RecordMergeFacilityMetadataField' } & {
      arrivalInstructions: { __typename?: 'RecordMergeStringField' } & Pick<
        Types.IRecordMergeStringField,
        'value'
      >
      equipments: { __typename?: 'RecordMergeEquipmentsField' } & {
        value?: Types.Maybe<
          Array<{ __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id' | 'key' | 'parentKey'>>
        >
      }
      requirements: { __typename?: 'RecordMergeFacilityRequirements' } & Pick<
        Types.IRecordMergeFacilityRequirements,
        'value'
      >
      safetyRequirements: { __typename?: 'RecordMergeStringField' } & Pick<
        Types.IRecordMergeStringField,
        'value'
      >
      services: { __typename?: 'RecordMergeFacilityServices' } & Pick<
        Types.IRecordMergeFacilityServices,
        'value'
      >
    }
  >
  schedule?: Types.Maybe<
    { __typename?: 'RecordMergeFacilityScheduleField' } & {
      sop: { __typename?: 'RecordMergeStringField' } & Pick<Types.IRecordMergeStringField, 'value'>
      schedulingNotes: { __typename?: 'RecordMergeStringField' } & Pick<
        Types.IRecordMergeStringField,
        'value'
      >
      rules: { __typename?: 'RecordMergeFacilityScheduleRulesField' } & {
        value: Array<
          { __typename?: 'FacilityScheduleRule' } & Pick<
            Types.IFacilityScheduleRule,
            | 'appointmentType'
            | 'autoScheduling'
            | 'schedulingMethod'
            | 'procedureRequirements'
            | 'workInsAllowed'
            | 'stopType'
            | 'unloadType'
            | 'tmsUrl'
            | 'tmsNotes'
          >
        >
      }
    }
  >
  hours: { __typename?: 'RecordMergeFacilityScheduleHours' } & {
    value?: Types.Maybe<
      Array<
        { __typename?: 'FacilityScheduleHour' } & Pick<
          Types.IFacilityScheduleHour,
          'id' | 'day' | 'startTime' | 'closed' | 'endTime' | 'stopType' | 'unloadType'
        >
      >
    >
  }
  contacts: Array<
    { __typename?: 'RecordMergeFacilityContactsField' } & {
      value?: Types.Maybe<
        Array<
          { __typename?: 'FacilityContact' } & Pick<
            Types.IFacilityContact,
            'id' | 'name' | 'email' | 'canScheduleFor' | 'contactRoles' | 'note'
          > & {
              contactMethods: Array<
                { __typename?: 'FacilityContactMethod' } & Pick<
                  Types.IFacilityContactMethod,
                  'id' | 'contactMethod' | 'value'
                >
              >
            }
        >
      >
    }
  >
  note: { __typename?: 'RecordMergeStringField' } & Pick<Types.IRecordMergeStringField, 'value'>
  shipperFacility?: Types.Maybe<
    { __typename?: 'ShipperFacility' } & Pick<Types.IShipperFacility, 'id' | 'uuid'>
  >
}

export const StopShipperFacilityFragmentDoc = gql`
  fragment StopShipperFacility on MergedFacility {
    metadata {
      arrivalInstructions {
        value
      }
      equipments {
        value {
          id
          key
          parentKey
        }
      }
      requirements {
        value
      }
      safetyRequirements {
        value
      }
      services {
        value
      }
    }
    schedule {
      sop {
        value
      }
      schedulingNotes {
        value
      }
      rules {
        value {
          appointmentType
          autoScheduling
          schedulingMethod
          procedureRequirements
          workInsAllowed
          stopType
          unloadType
          tmsUrl
          tmsNotes
        }
      }
    }
    hours {
      value {
        id
        day
        startTime
        closed
        endTime
        stopType
        unloadType
      }
    }
    contacts {
      value {
        id
        name
        email
        canScheduleFor
        contactRoles
        note
        contactMethods {
          id
          contactMethod
          value
        }
      }
    }
    note {
      value
    }
    shipperFacility {
      id
      uuid
    }
  }
`
